import { useMediaQuery, useTheme } from '@material-ui/core'
import { Pagination } from '@material-ui/lab'

import { PaymentTermBrief } from '../../types/walletPaymentTerm'
import PaymentTermListTable from './PaymentTermTable'
import useStyles from './styles/PaymentTermListDesktop.styles'

export interface PaymentTermListProps {
  refetch: () => void
  filteredPaymentTerms: PaymentTermBrief[]
  page: number
  perPage: number
  loading: boolean
  setPage: (value: number) => void
  numberOfPages: number
}
const PaymentTermListDesktop: React.FC<PaymentTermListProps> = ({
  refetch,
  filteredPaymentTerms,
  page,
  perPage,
  loading,
  numberOfPages,
  setPage
}) => {
  const theme = useTheme()
  const classes = useStyles()

  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <div>
      <PaymentTermListTable
        refetch={refetch}
        paymentTerms={filteredPaymentTerms.slice(
          (page - 1) * perPage,
          page * perPage
        )}
        loading={loading}
      />
      <div className={classes.paginationContainer}>
        <Pagination
          count={numberOfPages}
          color="primary"
          size={isSmallScreen ? 'small' : 'medium'}
          page={page}
          onChange={(_, value) => setPage(value)}
        />
      </div>
    </div>
  )
}
export default PaymentTermListDesktop
